import React, { useCallback, useMemo, useState } from 'react';
import { Box, Dropdown, Option, OptionKey, SearchInput, Text } from '@common-fe/common-fe';
import _ from 'lodash';

interface Props {
  value: OptionKey | null;
  onChange: (value: OptionKey) => void;
  options: Option[];
}
const PlanSelectDropdown: React.FC<Props> = ({ value, onChange, options }) => {
  const [expanded, setExpanded] = useState(false);
  const [currentSearch, setCurrentSearch] = useState('');

  const currentOptions = useMemo(() => {
    if (currentSearch?.trim()?.length > 0) {
      return options.filter((item) =>
        _.toLower((item.title as string) || '')
          .trim()
          .includes(_.toLower(currentSearch || '').trim())
      );
    }
    return options;
  }, [currentSearch, options]);
  const handlePickItem = useCallback(
    (key: OptionKey) => () => {
      onChange(key);
      setExpanded(false);
    },
    [onChange]
  );
  const currentTile = useMemo(() => {
    return options.find((option) => option.key === value)?.title;
  }, [value, options]);
  return (
    <Dropdown
      placeholder="Placeholder"
      prefix="Account"
      expanded={expanded}
      title={
        <Text color="textAccent" truncate title={currentTile}>
          {currentTile}
        </Text>
      }
      testId="plan-select-dropdown"
      onSetExpanded={setExpanded}
    >
      <Box>
        <Box pad="spacing12">
          <SearchInput value={currentSearch} onChange={setCurrentSearch} />
        </Box>
        <Box margin={{ horizontal: 'spacing12' }} height="1px" background="border1"></Box>
        <Box pad="spacing12" height={{ max: '400px' }} overflow="auto">
          {currentOptions.map((option) => (
            <Dropdown.Item
              isActive={value === option.key}
              truncate
              testId={`plan-select-dropdown_item_${option.key}`}
              title={option.title}
              key={option.key}
              onClick={handlePickItem(option.key)}
            >
              {option.title}
            </Dropdown.Item>
          ))}
          {currentOptions.length === 0 && <Text color="textDisabled">No results found</Text>}
        </Box>
      </Box>
    </Dropdown>
  );
};
export default PlanSelectDropdown;
